import EditTab from '@/components/toolbox/immoscoutpreview/Edit'
import ImmoScoutApi from '@/api/immoscout'
import Vue from 'vue'
import store from '@/store'

class ImmoScoutPreview {
  constructor (data) {
    this.id = data.id
    this.loaded = false
    this.previewFieldLayout = []
    this.toolboxErrors = null
    this.update(data)
    this.loadingPromise = this.init()
  }

  update (data) {
    for (let fieldName in data) {
      if (data.hasOwnProperty(fieldName)) {
        Vue.set(this, fieldName, data[fieldName])
      }
    }
  }

  async init () {
    if (!this.id || this.loaded) {
      this.loaded = true
      return this
    }
    let response = await ImmoScoutApi.preview(this.id)
    this.previewFieldLayout = response.data
    this.toolboxErrors = response.errors

    this.loaded = true
    return this
  }

  getLayer () {
    if (!this.layer) {
      return null
    }

    return store.getters['layer/get'](this.layer)
  }

  getToolboxTabs () {
    return {
      edit: {
        tab: EditTab,
        icon: 'edit'
      }
    }
  }
}

export default ImmoScoutPreview
